export const getDiffLink = (
  clientId: string,
  oldSummaryId: string,
  newSummaryId: string,
  year: string | number
) => {
  return `/clients/${clientId}/diffs/${oldSummaryId}/${newSummaryId}/${year}`;
};
